import { useState, useEffect, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "semantic-ui-react";
import ReactCanvasConfetti from "react-canvas-confetti";

import BingoSquare from "./BingoSquare";

import { gameActions } from "../../store/game-slice";

function BingoBoard(props) {
  const dispatch = useDispatch();

  const canvasStyles = {
    position: "fixed",
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0
  };

  const refAnimationInstance = useRef(null);

  const getInstance = useCallback((instance) => {
    refAnimationInstance.current = instance;
  }, []);

  const makeShot = useCallback((particleRatio, opts) => {
    refAnimationInstance.current &&
      refAnimationInstance.current({
        ...opts,
        origin: { y: 0.7 },
        particleCount: Math.floor(200 * particleRatio)
      });
  }, []);

  const fire = useCallback(() => {
    makeShot(0.25, {
      spread: 26,
      startVelocity: 55
    });

    makeShot(0.2, {
      spread: 60
    });

    makeShot(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8
    });

    makeShot(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2
    });

    makeShot(0.1, {
      spread: 120,
      startVelocity: 45
    });
  }, [makeShot]);

  const newCard = [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ];
  const winners = [
    [0, 1, 2, 3, 4],
    [5, 6, 7, 8, 9],
    [10, 11, 12, 13, 14],
    [15, 16, 17, 18, 19],
    [20, 21, 22, 23, 24],
    [0, 5, 10, 15, 20],
    [1, 6, 11, 16, 21],
    [2, 7, 12, 17, 22],
    [3, 8, 13, 18, 23],
    [4, 9, 14, 19, 24],
    [0, 6, 12, 18, 24],
    [4, 8, 12, 16, 20],
  ];
  const possibleWinners = winners.length;
  const themes = useSelector((state) => state.game.themes);
  const activeTheme = useSelector((state) => state.game.activeTheme);
  const icons = [...themes[activeTheme].icons];
  const clockRunning = useSelector((state) => state.game.clockRunning);
  const finalGameTime = useSelector((state) => state.game.finalGameTime);

  const [gameRestartKey, setGameRestartKey] = useState(Math.random());
  const [mydeck, setMyDeck] = useState(icons);
  const [myCard, setMyCard] = useState(newCard);
  const [doIHaveIt, setDoIHaveIt] = useState(false);
  const [currentDraw, setCurrentDraw] = useState(100);
  const [selected, setSelected] = useState([]);
  const [turn, setTurn] = useState(0);
  const [currentDrawNumber, setCurrentDrawNumberImg] = useState(null);
  const [currentDrawingNumberDeck, setCurrentDrawingNumberDeck] = useState([]);
  const [currentBingoCardSquares, setCurrentBingoCardSquares] = useState([]);

  const [checkDrawOpen, setCheckDrawOpen] = useState(false);
  const [youWonOpen, setYouWonOpen] = useState(false);

  const [drawButtonDisabled, setDrawButtonDisabled] = useState(false);

  useEffect(() => {
    if (props.isGameRestarted) {
      // reset state
      setGameRestartKey(Math.random());
      setMyCard(newCard);
      setDoIHaveIt(false);
      setCurrentDraw(100);
      setTurn(0);
      setSelected([]);
      setCurrentDrawNumberImg(null);

      // init drawing deck
      let drawingNumberDeck = [];
      shuffle(mydeck);
      for (let i = 0; i < mydeck.length; i++) {
        drawingNumberDeck[i] = mydeck[i];
      }
      shuffle(drawingNumberDeck);
      setCurrentDrawingNumberDeck(drawingNumberDeck);

      // init bingo squares
      let bingoCardSquares = [];
      for (let i = 0; i < 25; i++) {
        bingoCardSquares.push({
          index: i,
          icon: "images/" + activeTheme + "/" + mydeck[i],
          loser: false
        });
      }
      setCurrentBingoCardSquares(bingoCardSquares);
    }
  }, [props.isGameRestarted]);

  useEffect(() => {
    // auto-draw if new drawing deck is generated
    //Draw();
  }, [currentDrawingNumberDeck]);

  useEffect(() => {
    // if selected array is updated, check for winner
    CheckIfIWon();
  }, [selected]);

  function shuffle(array) {
    let currentIndex = array.length,
      randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex != 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  }

  function CheckAnswer(myNum) {
    if (myNum == currentDraw) {
      const updateMyCard = myCard.map((c, i) => {
        if (i === myNum) {
          return 1;
        } else {
          return c;
        }
      });

      setMyCard(updateMyCard);

      setSelected((selected) => [...selected, myNum]);
    }
  }

  function Draw() {
    let tempCurrentDraw = currentDraw;
    let tempDoIHaveit = doIHaveIt;

    if ((tempDoIHaveit && myCard[tempCurrentDraw] == 0) && turn > 0) {
      setCheckDrawOpen(true);
    } else {
      for (let i = 0; i < currentDrawingNumberDeck.length; i++) {
        if (String(mydeck[i]) == String(currentDrawingNumberDeck[turn])) {
          tempCurrentDraw = i;
          tempDoIHaveit = false;
          if(tempCurrentDraw < 25){tempDoIHaveit = true;}
          break;
        }
      }

      setCurrentDrawNumberImg(currentDrawingNumberDeck[turn]);
      setDoIHaveIt(tempDoIHaveit);
      setCurrentDraw(tempCurrentDraw);

      setTurn((turn) => turn + 1);
    }
  }

  function btnDrawNumberClickHandler() {
    if (!clockRunning) {
      props.onStartStopClockHandler(true, false);
    }
    Draw();
  }

  function btnPlayAgainClickHandler() {
    setYouWonOpen(false);
    setDrawButtonDisabled(false);
    dispatch(gameActions.setGameRestarted(true));
  }

  function CheckIfIWon() {
    let winningArray = new Array();

    let hasWon = false;

    for (let i = 0; i < possibleWinners; i++) {
      let cellExists = 0;
      for (let j = 0; j < 5; j++) {
        if (selected.includes(winners[i][j])) {
          cellExists++;
        }
      }

      // If all 5 winner cells exist in selected array alert success message
      if (cellExists == 5) {
        hasWon = true;
        winningArray = winners[i];
        break;
      }
    }

    if(hasWon) {
      props.onStartStopClockHandler(false, true);
      setDrawButtonDisabled(true);
      
      let bingoCardSquares = currentBingoCardSquares;
      for (let i = 0; i < 25; i++) {
        // check for winning square here and change a prop on the square
        for (let w = 0; w < winningArray.length; w++) {
          if(selected.includes(i)) {
            if(!winningArray.includes(i)){
              bingoCardSquares[i].loser = true;
              
            }

          }
          else{
            bingoCardSquares[i].loser = true;
          }
        }
        
      }
      setCurrentBingoCardSquares(bingoCardSquares);

      fire();

      setTimeout(function(){
        setYouWonOpen(true);
      }, 3000);


    }

  }

  return (
    
    <section className="bingo-board">
      <div className="draw">
        {!currentDrawNumber && (
          <img
            className="draw-instruction"
            src="images/start.svg"
            alt="Click DRAW to begin game"
          />
        )}
        <div className="current-draw-container">
          <div className="current-draw">
            {currentDrawNumber && (
              <img
                key={currentDrawNumber}
                className="animate slide"
                src={`images/${activeTheme}/${currentDrawNumber}`}
                alt={currentDrawNumber}
              />
            )}
          </div>
        </div>
        <button onClick={btnDrawNumberClickHandler} className="draw-btn" disabled={drawButtonDisabled}>
          <img src="images/draw-btn.svg" alt="Draw" />
        </button>
      </div>
      <div className="bingo-container">
        <div className="bingo-card">
          {currentBingoCardSquares.map((square) => (
            <BingoSquare
              key={square.index}
              index={square.index}
              icon={square.icon}
              onClick={CheckAnswer}
              selected={selected.includes(square.index)}
              gameRestartKey={gameRestartKey}
              loser={square.loser}
            />
          ))}
        </div>
      </div>
      <Modal className="modal-nobg animate flip" open={checkDrawOpen}>
        <Modal.Content>
          <div className="oops-container">
            <img
              key={currentDrawNumber}
              className="oops-draw"
              src={`images/${activeTheme}/${currentDrawNumber}`}
              alt={currentDrawNumber}
            />
          </div>

          <img src="images/oops.png" />
          <button
            className="mt"
            type="submit"
            onClick={() => {
              setCheckDrawOpen(false);
            }}
          >
            Back to Card
          </button>
        </Modal.Content>
      </Modal>
      <Modal className="modal-nobg animate flip" open={youWonOpen}>
        <Modal.Content>
          <img src="images/you-won.svg" />
          <p className="final-time">Your Time: {finalGameTime}</p>
          <button
            type="submit"
            onClick={() => {
              btnPlayAgainClickHandler(false);
            }}
          >
            Play Again
          </button>
        </Modal.Content>
      </Modal>
      <ReactCanvasConfetti refConfetti={getInstance} style={canvasStyles} />
    </section>
  );
}

export default BingoBoard;
